<template>
  <div ref="chart" id="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as am4charts from '@amcharts/amcharts4/charts';

export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
    ]),
  },
  mounted() {
    this.generateGraphic();
  },
  methods: {
    generateGraphic() {
      this.chart = this.am4core.create(this.$refs.chart, am4charts.XYChart);
      this.chart.height = this.am4core.percent(100);
      this.chart.cursor = new am4charts.XYCursor();
      this.chart.cursor.behavior = 'zoomY';
      this.chart.data = this.data;
      this.chart.showAllValueLabels = true;
      this.chart.dateFormatter.inputDateFormat = 'HH';

      // Create category axis
      this.chart.yAxes.push(new am4charts.ValueAxis());

      // create date axis
      const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 30;
      dateAxis.dateFormats.setKey('hour', 'HH');
      dateAxis.baseInterval = {
        timeUnit: 'hour',
        count: 1,
      };

      // Create series
      const series = this.chart.series.push(new am4charts.LineSeries());
      series.dataFields.dateX = 'hour';
      series.dataFields.valueY = 'unanswered';
      series.tooltipText = '{valueY}';
      series.strokeWidth = 2;
      series.fill = this.am4core.color('#fcae32');
      series.stroke = this.am4core.color('#fcae32');

      const series1 = this.chart.series.push(new am4charts.LineSeries());
      series1.dataFields.dateX = 'hour';
      series1.dataFields.valueY = 'unsolved';
      series1.tooltipText = '{valueY}';
      series1.strokeWidth = 2;
      series1.fill = this.am4core.color('#f46860');
      series1.stroke = this.am4core.color('#f46860');

      const series2 = this.chart.series.push(new am4charts.LineSeries());
      series2.dataFields.dateX = 'hour';
      series2.dataFields.valueY = 'solved';
      series2.tooltipText = '{valueY}';
      series2.strokeWidth = 2;
      series2.fill = this.am4core.color('#65e4a1');
      series2.stroke = this.am4core.color('#65e4a1');

      const series3 = this.chart.series.push(new am4charts.LineSeries());
      series3.dataFields.dateX = 'hour';
      series3.dataFields.valueY = 'queued';
      series3.tooltipText = '{valueY}';
      series3.strokeWidth = 2;
      series3.fill = this.am4core.color('#4bdae7');
      series3.stroke = this.am4core.color('#4bdae7');
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  height: 100%;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Distributions/LineGraphic.vue